// A redirect that says why: a person who opens a page their role cannot use
// lands somewhere useful with a one-line notice, never a silent bounce.
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import toast from "react-hot-toast";

const RoleDenied = ({ to, notice }) => {
  useEffect(() => {
    if (notice) toast(notice, { id: `denied:${to}` });
  }, [to, notice]);
  return <Navigate to={to} replace />;
};

export default RoleDenied;
